// ─── NAVIGATION ───────────────────────────────────────────────
export const NAV_LINKS = [
  { href: '#services',    label: 'Services' },
  { href: '#products',    label: 'Products' },
  { href: '#process',     label: 'Process' },
  { href: '#cloud',       label: 'Cloud' },
  { href: '#internship',  label: 'Internship' },
  { href: '#news',        label: 'News' },
  { href: '#contact',     label: 'Contact' },
];

// ─── TICKER ────────────────────────────────────────────────────
export const TICKER_ITEMS = [
  '🤖 AI Agents', '☁️ Azure Cloud', '⚡ LangChain',
  '📱 Flutter Apps', '💻 React / Next.js', '🔧 .NET 8',
  '🔐 DevSecOps', '🌐 Digital Transformation', '📊 Power BI',
  '🤝 Mentorship', '🏪 BuyAndSell', '🏘️ NeighbourPro',
];

// ─── SERVICES ──────────────────────────────────────────────────
export const SERVICES = [
  {
    icon: '🤖',
    title: 'AI Agent Development',
    desc: 'Custom LLM-powered agents, RAG pipelines, autonomous workflows, and intelligent assistants using LangChain, OpenAI, and Azure AI.',
    tags: ['LangChain', 'OpenAI', 'RAG', 'Agents'],
    color: 'rgba(0,177,79,.1)',
    textColor: 'var(--g)',
  },
  {
    icon: '☁️',
    title: 'Cloud Consulting',
    desc: 'Azure architecture design, cloud migration strategy, infrastructure-as-code, cost optimisation, and 24/7 managed services.',
    tags: ['Azure', 'Terraform', 'DevOps', 'Migration'],
    color: 'rgba(59,130,246,.1)',
    textColor: '#2563EB',
  },
  {
    icon: '🔄',
    title: 'Digital Transformation',
    desc: 'End-to-end business process re-engineering, legacy modernisation, API integration, and workflow automation at scale.',
    tags: ['Automation', 'API', 'Modernisation', 'Integration'],
    color: 'rgba(139,92,246,.1)',
    textColor: '#7C3AED',
  },
  {
    icon: '📱',
    title: 'Mobile & Web Apps',
    desc: 'Cross-platform Flutter apps, React / Next.js web applications, and progressive web apps with performance-first architecture.',
    tags: ['Flutter', 'React', 'Next.js', 'PWA'],
    color: 'rgba(245,158,11,.1)',
    textColor: '#D97706',
  },
  {
    icon: '🔧',
    title: '.NET & Backend',
    desc: 'Enterprise .NET 8 APIs, microservices architecture, SQL & NoSQL databases, gRPC, SignalR real-time solutions.',
    tags: ['.NET 8', 'Microservices', 'SQL', 'gRPC'],
    color: 'rgba(239,68,68,.1)',
    textColor: '#DC2626',
  },
  {
    icon: '🛡️',
    title: 'DevSecOps & CI/CD',
    desc: 'GitHub Actions, Azure DevOps pipelines, container security, vulnerability scanning, and zero-downtime deployment strategies.',
    tags: ['GitHub Actions', 'Docker', 'Security', 'CI/CD'],
    color: 'rgba(6,182,212,.1)',
    textColor: '#0891B2',
  },
];

// ─── PRODUCTS ──────────────────────────────────────────────────
export const PRODUCTS = [
  {
    id: 'devbrains',
    emoji: '🧠',
    name: 'DevBrains',
    subtitle: 'Mentor Application',
    badge: 'Platform 01 — Mentorship',
    badgeColor: 'rgba(0,177,79,.1)',
    badgeBorder: 'var(--gm)',
    badgeText: 'var(--g)',
    launchDate: '2026-09-28T00:00:00+05:30',
    launchLabel: '🚀 Launching September 28, 2026',
    launching: true,
    description: 'An AI-powered mentorship platform connecting developers with industry professionals through intelligent matching, structured learning roadmaps, and live collaboration tools.',
    features: [
      { icon: '🧠', text: 'Smart AI mentor-mentee matching algorithm' },
      { icon: '📈', text: 'Structured developer roadmaps & milestones' },
      { icon: '💻', text: 'Live code review & pair programming' },
      { icon: '🎯', text: 'Goal tracking & achievement badges' },
      { icon: '💬', text: 'Built-in video calls & chat rooms' },
    ],
    ctaLabel: '💬 Get Early Access',
    ctaHref: 'https://wa.me/918123629993?text=I want early access to DevBrains launching Sep 28 2026',
    tabLabel: 'DevBrains',
    tabBadge: 'Sep 28',
    tabBadgeStyle: { background:'rgba(0,177,79,.15)', color:'#00843D' },
  },
  {
    id: 'buyandsell',
    emoji: '🛒',
    name: 'BuyAndSell',
    subtitle: 'Smart Marketplace',
    badge: 'Platform 02 — Marketplace',
    badgeColor: 'rgba(245,158,11,.1)',
    badgeBorder: 'rgba(245,158,11,.3)',
    badgeText: '#d97706',
    launchDate: null,
    launchLabel: '⏳ Coming Soon — 2026',
    launching: false,
    description: 'A hyper-local AI-powered buy & sell marketplace with smart price suggestions, verified seller profiles, integrated payments, and real-time demand analytics.',
    features: [
      { icon: '🤖', text: 'AI price recommendation engine' },
      { icon: '✅', text: 'KYC-verified seller badges' },
      { icon: '💳', text: 'UPI / card integrated checkout' },
      { icon: '📍', text: 'Hyper-local geo-based discovery' },
      { icon: '📊', text: 'Market demand analytics dashboard' },
    ],
    ctaLabel: '🔔 Notify Me on Launch',
    ctaHref: 'https://wa.me/918123629993?text=Please notify me when BuyAndSell launches in 2026',
    tabLabel: 'BuyAndSell',
    tabBadge: 'Soon',
    tabBadgeStyle: { background:'rgba(245,158,11,.15)', color:'#B45309' },
  },
  {
    id: 'neighbourpro',
    emoji: '🏘️',
    name: 'NeighbourPro',
    subtitle: 'Community Services',
    badge: 'Platform 03 — Hyperlocal',
    badgeColor: 'rgba(6,182,212,.1)',
    badgeBorder: 'rgba(6,182,212,.3)',
    badgeText: '#0284c7',
    launchDate: null,
    launchLabel: '⏳ Coming Soon — 2026',
    launching: false,
    description: 'A neighbourhood service platform connecting residents with trusted local pros — electricians, plumbers, tutors, delivery — powered by AI trust scores and community ratings.',
    features: [
      { icon: '⭐', text: 'AI trust scoring for service providers' },
      { icon: '📍', text: 'Proximity-based provider discovery' },
      { icon: '🔔', text: 'Real-time booking & notifications' },
      { icon: '💬', text: 'In-app chat & service tracking' },
      { icon: '🛡️', text: 'Escrow-protected payments' },
    ],
    ctaLabel: '🔔 Notify Me on Launch',
    ctaHref: 'https://wa.me/918123629993?text=Please notify me when NeighbourPro launches in 2026',
    tabLabel: 'NeighbourPro',
    tabBadge: 'Soon',
    tabBadgeStyle: { background:'rgba(6,182,212,.15)', color:'#0284c7' },
  },
];

// ─── PROCESS STEPS ─────────────────────────────────────────────
export const PROCESS_STEPS = [
  { n: '01', icon: '🔍', title: 'Discovery & Audit', desc: 'Deep-dive into your systems, goals, and pain points. We map the full technical landscape.' },
  { n: '02', icon: '🗺️', title: 'Strategy & Roadmap', desc: 'A phased, prioritised plan with clear milestones, KPIs, and technology recommendations.' },
  { n: '03', icon: '⚡', title: 'Agile Build', desc: '2-week sprints with daily standups. Continuous delivery, QA, and stakeholder demos.' },
  { n: '04', icon: '🚀', title: 'Deploy & Scale', desc: 'Zero-downtime deployment to Azure/GCP, with auto-scaling, monitoring, and alerting.' },
  { n: '05', icon: '📊', title: 'Monitor & Evolve', desc: 'Real-time performance dashboards, monthly reviews, and proactive optimisation.' },
];

// ─── CLOUD SERVICES ────────────────────────────────────────────
export const CLOUD_SERVICES = [
  { icon: '🏗️', title: 'Architecture Design', desc: 'Well-Architected Framework reviews, cloud-native patterns, microservices design.' },
  { icon: '🚚', title: 'Cloud Migration', desc: 'Lift-and-shift to re-platform — risk-free migration with validated rollback plans.' },
  { icon: '💰', title: 'Cost Optimisation', desc: 'FinOps practices, reserved instance strategy, rightsizing — typically 30–50% savings.' },
  { icon: '🔐', title: 'Security & Compliance', desc: 'Zero-trust architecture, IAM policies, GDPR/SOC2 compliance frameworks.' },
  { icon: '🔄', title: 'DevOps & CI/CD', desc: 'Automated pipelines, infrastructure-as-code, container orchestration with AKS.' },
  { icon: '📊', title: 'Monitoring & SRE', desc: 'Azure Monitor, Log Analytics, custom dashboards, SLO/SLI definitions, incident response.' },
];

// ─── INTERNSHIP ────────────────────────────────────────────────
export const INTERNSHIP_TRACKS = [
  { icon: '🤖', label: 'AI / LangChain' },
  { icon: '☁️', label: 'Cloud / Azure' },
  { icon: '📱', label: 'Flutter Mobile' },
  { icon: '🌐', label: 'React / Next.js' },
  { icon: '🔧', label: '.NET Backend' },
  { icon: '📊', label: 'Data / Power BI' },
];

// ─── NEWS ──────────────────────────────────────────────────────
export const NEWS = [
  {
    cat: 'Product Launch',
    catColor: '#00B14F',
    catBg: 'rgba(0,177,79,.1)',
    date: 'Sep 2026',
    title: 'DevBrains Launches — AI Mentorship Platform Goes Live',
    desc: 'JSDevBrains is proud to announce the launch of DevBrains on September 28, 2026 — connecting developers with expert mentors through AI-powered matching.',
  },
  {
    cat: 'Company News',
    catColor: '#7C3AED',
    catBg: 'rgba(139,92,246,.1)',
    date: 'Jun 2026',
    title: 'JSDevBrains Expands to Malaysia & Singapore',
    desc: 'Following strong demand from Southeast Asia, JSDevBrains opens regional operations in KL and Singapore to serve enterprise clients.',
  },
  {
    cat: 'AI Research',
    catColor: '#0891B2',
    catBg: 'rgba(6,182,212,.1)',
    date: 'May 2026',
    title: 'JSDevBrains AI White Paper: Enterprise RAG Architecture',
    desc: 'Our engineering team publishes a comprehensive guide on production-ready Retrieval-Augmented Generation systems for Indian enterprises.',
  },
  {
    cat: 'Partnership',
    catColor: '#D97706',
    catBg: 'rgba(245,158,11,.1)',
    date: 'Apr 2026',
    title: 'Microsoft Azure Advanced Specialisation Achieved',
    desc: 'JSDevBrains earns the Microsoft Azure Advanced Specialisation in AI & Machine Learning, joining an elite group of certified partners.',
  },
];

// ─── TESTIMONIALS ──────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    stars: 5,
    text: 'JSDevBrains transformed our entire data pipeline with an AI agent that saves our team 40 hours per week. Exceptional technical depth and delivery speed.',
    name: 'Rajan Mehta',
    role: 'CTO, FinanceFlow India',
    avatar: 'RM',
    avatarBg: 'linear-gradient(135deg,#00B14F,#00843D)',
  },
  {
    stars: 5,
    text: 'Their Azure migration was flawless — zero downtime, 38% cost reduction, and fully automated CI/CD. The team genuinely cares about your business outcomes.',
    name: 'Sarah Chen',
    role: 'Engineering Lead, LogiSync SG',
    avatar: 'SC',
    avatarBg: 'linear-gradient(135deg,#3B82F6,#1D4ED8)',
  },
  {
    stars: 5,
    text: 'We built our Flutter app with JSDevBrains in 10 weeks. On time, on budget, and the code quality is outstanding. Our App Store rating is 4.8★.',
    name: 'Priya Sundaram',
    role: 'Founder, HealthTrack App',
    avatar: 'PS',
    avatarBg: 'linear-gradient(135deg,#7C3AED,#5B21B6)',
  },
];

// ─── TECH TAGS (marquee) ───────────────────────────────────────
export const TECH_TAGS = [
  '.NET 8', 'React', 'Next.js', 'Flutter', 'Azure', 'Azure AI',
  'LangChain', 'OpenAI GPT-4o', 'LlamaIndex', 'Docker', 'Kubernetes',
  'PostgreSQL', 'MongoDB', 'Redis', 'Terraform', 'GitHub Actions',
  'Power BI', 'TypeScript', 'Python', 'Go', 'FastAPI', 'SignalR',
];

// ─── CHATBOT FAQs ──────────────────────────────────────────────
export const CHAT_FAQS = [
  {
    q: '👋 What services do you offer?',
    a: 'We offer AI Agent Development, Cloud Consulting (Azure), Digital Transformation, Mobile & Web Apps (Flutter/React), .NET Backend Engineering, and DevSecOps/CI-CD. Every engagement is tailored to your specific business needs.',
  },
  {
    q: '💰 What are your pricing models?',
    a: 'We offer three models:\n• Fixed-price projects (well-defined scope)\n• Time & materials (ongoing/evolving work)\n• Monthly retainer (dedicated team + SLA)\nPrices start from ₹50,000 for small projects. Message us on WhatsApp for a free estimate!',
  },
  {
    q: '⏱️ How fast can you start?',
    a: 'We can kick off discovery within 2–3 business days of signing. First sprint delivery is typically within 2 weeks. For urgent projects, we offer an expedited onboarding track.',
  },
  {
    q: '🧠 What is DevBrains?',
    a: 'DevBrains is our upcoming AI-powered mentorship platform (launching September 28, 2026) that connects developers with industry experts through intelligent matching, structured roadmaps, and live collaboration tools.',
  },
  {
    q: '🛒 Tell me about BuyAndSell',
    a: 'BuyAndSell is our hyper-local AI marketplace platform (coming 2026) with smart price recommendations, KYC-verified sellers, UPI/card payments, and real-time market demand analytics.',
  },
  {
    q: '🏘️ What is NeighbourPro?',
    a: 'NeighbourPro (coming 2026) is a neighbourhood services platform connecting residents with trusted local professionals — electricians, plumbers, tutors, and more — powered by AI trust scores.',
  },
  {
    q: '🌍 Do you work with international clients?',
    a: 'Yes! We have active clients in India, Malaysia, Singapore, UAE, UK, and the US. We work across time zones and communicate in English. All contracts are in USD or INR.',
  },
  {
    q: '📍 Where are you located?',
    a: 'Our headquarters is in Thanjavur, Tamil Nadu, India (SR Complex 36/1c Pkt Road, Thiruchitrambalam, 614628). We work 100% remotely with clients worldwide.',
  },
  {
    q: '🎓 Do you offer internships?',
    a: 'Yes! We have structured 3-6 month internship programmes in AI/LangChain, Azure Cloud, Flutter, React, .NET, and Data/Power BI. Interns get real project exposure, mentorship, and a performance certificate.',
  },
  {
    q: '📞 How do I contact you?',
    a: 'Fastest: WhatsApp us at +91 81236 29993 (replies within minutes). Or use the contact form on this page — we respond within 24 hours. You can also email us at hello@jsdevbrains.com.',
  },
];
